<template>
  <div class="login">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-0">
            <v-card-text>
              <a :href="homepage" class="text-deco">
                <div class="pb-3">
                  <v-img width="200" :src="siteConfig.logo" class="mx-auto"></v-img>
                </div>
              </a>
              <div class="pb-2 text-center text-subtitle-1 font-weight-bold black--text">Buat akun sekarang</div>
              <div class="text-subtitle-2 py-4">
                <span class="black--text">Sudah punya akun?</span>
                <router-link to="/login">
                  <span class="font-weight-bold pl-2 black--text">Masuk di sini</span>
                </router-link>
              </div>
              <v-form ref="formRegister" role="form" v-on:submit.prevent="onRegister">
                <div class="pb-5">
                  <!-- <div class="text-subtitle-2 text--darken-2 pb-1">Nama</div> -->
                  <v-text-field v-model="email" :rules="emailRules" hide-details="auto" color="dark" validate-on-blur
                    label="Email" outlined class="color-black rounded-lg" height="40" dense
                    @focus="() => fieldErrors.email = ''" @change="removeSpace"
                    :error-messages="fieldErrors.email"></v-text-field>
                </div>
                <div class="pb-5">
                  <v-text-field v-model="name" :rules="usernameRules" hide-details="auto" color="dark" validate-on-blur
                    label="Nama" outlined class="color-black rounded-lg" height="40" dense
                    @focus="() => fieldErrors.name = ''" :error-messages="fieldErrors.name"></v-text-field>
                </div>
                <!-- <div class="pb-5">
                  <v-text-field v-model="email" :rules="emailRules" hide-details="auto" color="dark" validate-on-blur
                    label="Email" outlined class="color-black rounded-lg" height="40" dense
                    @focus="() => fieldErrors.email = ''" :error-messages="fieldErrors.email"></v-text-field>
                </div> -->
                <div class="pb-5">
                  <v-row>
                    <v-col md="6" cols="6" class="py-0">
                      <!-- <div class="text-subtitle-2 text--darken-2 pb-1">Password</div> -->
                      <v-text-field v-model="password" :rules="passwordRules" hide-details="auto"
                        @click:append="showPassword" :type="passwordType" :append-icon="passwordIcon" color="dark"
                        validate-on-blur label="Password" outlined class="color-black rounded-lg" height="40" dense
                        @focus="() => fieldErrors.password = ''" :error-messages="fieldErrors.password"></v-text-field>
                    </v-col>
                    <v-col md="6" cols="6" class="py-0">
                      <!-- <div class="text-subtitle-2 text--darken-2 pb-1">Ulangi Password</div> -->
                      <v-text-field v-model="repassword" :rules="repasswordRules" hide-details="auto"
                        @click:append="showrePassword" :type="repasswordType" :append-icon="repasswordIcon" color="dark"
                        validate-on-blur label="Ulangi Password" outlined class="color-black rounded-lg" height="40"
                        dense></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <div class="pb-5">
                  <!-- <div class="text-subtitle-2 text--darken-2 pb-1">Nomor Handphone</div> -->
                  <v-text-field v-model="mobilephone" :rules="mobilephoneRules" hide-details="auto"
                    @keypress="onlyNumber" @paste="validatePaste($event)" color="dark" validate-on-blur
                    label="Nomor Handphone" outlined class="color-black rounded-lg" height="40" dense
                    @focus="() => fieldErrors.mobilephone = ''"
                    :error-messages="fieldErrors.mobilephone"></v-text-field>
                </div>
                <div class="pb-5">
                  <!-- <div class="text-subtitle-2 text--darken-2 pb-1">Referal (Nomor Handphone)</div> -->
                  <!-- @keypress="onlyNumber" -->
                  <!-- :readonly="disabled_referal" -->
                  <v-text-field v-model="referral" :rules="(referral) ? [] : []" hide-details="auto"
                    @paste="validatePaste($event, true)" color="dark" validate-on-blur label="Referral (Optional)"
                    outlined class="color-black rounded-lg" height="40" dense @focus="() => fieldErrors.referral = ''"
                    :error-messages="fieldErrors.referral"></v-text-field>
                  <v-row>
                    <v-col cols="12" class="pt-1">
                      <v-checkbox v-model="aggreement" :rules="agreeRules" class="small-check mt-0">
                        <template v-slot:label>
                          <div class="black--text">
                            Saya setuju dengan
                            <router-link _target="_blank" to="/page/syarat-dan-ketentuan"
                              class="black--text font-weight-bold">syarat dan ketentuan</router-link>, serta
                            <router-link _target="_blank" to="/page/kebijakan-privasi"
                              class="font-weight-bold black--text">kebijakan privasi
                              {{ siteConfig.meta_title }}</router-link>
                          </div>
                        </template>
                      </v-checkbox>
                      <!-- <div style="text-align:right;">
                        <a
                          href="/page/kebijakan-privasi"
                          target="_blank"
                        >Syarat penggunaan dan kebijakan privasi.</a>
                      </div>-->
                    </v-col>
                  </v-row>
                </div>
                <div class="pt-0">
                  <!-- <v-btn
                    @click.prevent="modalShow"
                    depressed
                    color="black"
                    class="col-12 rounded-lg white--text"
                  >
                    <div class="subtitle-2">Show</div>
                  </v-btn>-->
                  <v-btn v-if="isAttempting" x-large depressed color="black" class="col-12 rounded-lg white--text">
                    <div class="subtitle-2">Sedang Diproses ...</div>
                  </v-btn>
                  <v-btn v-else x-large depressed color="black" class="col-12 rounded-lg white--text" type="submit">
                    <div class="subtitle-2">DAFTAR</div>
                  </v-btn>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" persistent max-width="580" content-class="rounded-lg" scrollable
      @keydown.esc="dialog = false">
      <v-card>
        <v-card-title class="h6">
          <span class="black--text text-uppercase font-weight-bold">Konfirmasi Pendaftaran</span>
          <v-spacer></v-spacer>
          <v-btn text small color="pink" class="mr-n4" @click="modalHide">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0" id="contener">
          <v-form ref="formAddAddress" role="form">
            <div class="py-0">
              <v-divider class="d-none"></v-divider>
            </div>
            <v-row align="center" justify="center">
              <v-col cols="12">
                <div class="pb-4">Silahkan isi kode referral Anda, atau biarkan kosong bila Anda tidak mengetahui kode
                  referralnya.</div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn @click.prevent="modalHide" color="#FFF2F1" depressed
            class="text-capitalize font-weight-bold rounded-lg pink--text" height="45" width="150">Batal</v-btn>
          <v-btn v-if="isAttempting" color="#272727" depressed
            class="text-capitalize font-weight-bold rounded-lg white--text" height="45" width="150" :readonly="true">
            <div class="subtitle-2">sedang diproses...</div>
          </v-btn>
          <v-btn v-else @click.prevent="actIgnoreReferral" color="#272727" depressed
            class="text-capitalize font-weight-bold rounded-lg white--text" height="45" width="150">Lanjutkan</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

import authHelper from "@/helpers/auth";

function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export default {
  components: {},
  data() {
    return {
      homepage: process.env.VUE_APP_HOMEPAGE,

      isIgnoreReferral: false,
      dialog: false,
      disabled_referal: false,
      responseData: "The Best",
      alertColor: "red",
      showme: false,
      password: "",
      repassword: "",
      username: "",
      name: "",
      email: "",
      mobilephone: "",
      referral: "",
      passwordType: "password",
      passwordIcon: "mdi-eye",
      repasswordType: "password",
      repasswordIcon: "mdi-eye",
      aggreement: false,
      // userusernameRules: [v => !!v || "Username tidak boleh kosong"],
      userusernameRules: [
        v => !!v || "Email tidak boleh kosong",
        v => v.length > 2 || "Email minimal 3 karakter",
        v => v.length < 31 || "Email maksimal 30 karakter"
      ],
      usernameRules: [v => !!v || "Nama tidak boleh kosong"],
      passwordRules: [
        v => !!v || "Password tidak boleh kosong",
        v => v.length > 5 || "Password minimal 6 karakter",
        v => v.length <= 20 || "Password maksimal 20 karakter"
      ],
      repasswordRules: [
        v => !!v || "Konfirmasi Password Anda",
        v => v === this.password || "Konfirmasi Password tidak cocok"
      ],
      mobilephoneRules: [
        v => !!v || "Nomor Handphone tidak boleh kosong",
        v => !isNaN(parseInt(v)) || "Format Nomor Handphone tidak sesuai"
      ],
      referalRules: [
        v => !isNaN(parseInt(v)) || "Format Nomor Handphone tidak sesuai"
      ],
      emailRules: [
        v => !!v || "Email tidak boleh kosong",
        v => !!validateEmail(v) || "Format Email tidak sesuai"
      ],
      agreeRules: [v => !!v || ""]
    };
  },
  async beforeMount() {
    await this.getSiteConfig()
    // console.log("siteconf", this.siteConfig.favicon)
    var link = await document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = await 'image/x-icon';
    link.rel = await 'shortcut icon';
    link.href = await this.siteConfig.favicon;
    await document.getElementsByTagName('head')[0].appendChild(link);
    console.log(" this.siteConfig.favicon", this.siteConfig.favicona)
  },
  computed: {

    ...mapState("kiriminaja", [
      "siteConfig",
    ]),
    ...mapState("auth", ["isAuth", "isAttempting", "alerts", "fieldErrors"])
  },
  methods: {
    ...mapActions("kiriminaja", [
      "getSiteConfig",
    ]),
    modalShow() {
      this.dialog = true;
    },
    modalHide() {
      this.dialog = false;
    },
    ...mapActions("auth", ["register", "login"]),
    ...mapMutations(["makeAlert"]),

    async validatePaste(val, ref) {
      let pasted = await val.clipboardData.getData("text");
      setTimeout(() => {
        if (!parseInt(pasted)) {
          if (ref === true) {
            this.referral = "";
          } else {
            this.mobilephone = "";
          }
        }
      });
    },
    showPassword() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
        this.passwordIcon = "mdi-eye-off";
      } else {
        this.passwordType = "password";
        this.passwordIcon = "mdi-eye";
      }
    },
    showrePassword() {
      if (this.repasswordType == "password") {
        this.repasswordType = "text";
        this.repasswordIcon = "mdi-eye-off";
      } else {
        this.repasswordType = "password";
        this.repasswordIcon = "mdi-eye";
      }
    },
    removeSpace() {
      // console.log("username",this.username)
      if (this.username != "") {
        this.username = this.username.replace(/\s+/g, "").toLowerCase();
      }
    },
    async actIgnoreReferral() {
      this.isIgnoreReferral = await true;
      await this.onRegister();
    },
    onRegister() {
      if (this.$refs.formRegister.validate()) {
        if (this.isIgnoreReferral == false && this.referral == "") {
          this.modalShow();
          return false;
        }
        this.username = this.username.trim();
        let params = {
          username: this.username,
          name: this.name,
          email: this.email,
          mobilephone: this.mobilephone,
          referral: this.referral,
          password: this.password
        };
        this.register(params)
          .then(() => {
            this.isIgnoreReferral = false;
            this.$router.push({
              name: "login"
            });
            this.makeAlert({
              code: "success",
              type: "success",
              message: "Proses Pendaftaran berhasil dilakukan",
              show: true
            });
          })
          .catch(() => {
            this.isIgnoreReferral = false;
            // console.log("respError", respError);
            // console.log("err2", err2);
            this.makeAlert({
              code: "error_response",
              type: "error",
              message: "Proses Pendaftaran gagal dilakukan",
              show: true
            });
            this.dialog = false
          });
      }
    }
  },
  created() {
    this.$store.dispatch("setPageTitle", "Daftar");
    let referral = authHelper.getReferal();
    if (referral) {
      this.referral = referral.replace(/"/g, "");
      this.disabled_referal = true;
    } else {
      this.disabled_referal = false;
    }
  }
};
</script>
